import React, { useState } from 'react';
import { carrierApi } from '../../firebase/functionsService';
import { LICENSE_CLASSES } from '../../utils/carrierRoles';
import Field from './Field';
import { ui } from './carrierStyles';

// Førerkortklasser og språk for en sjåfør. Lagres på medlemmet (organizations/{orgId}/members/{uid}).
export default function DriverProfileForm({ orgId, member, onDone }) {
  const [classes, setClasses] = useState(member.driverProfile?.licenseClasses ?? []);
  const [languages, setLanguages] = useState((member.driverProfile?.languages ?? []).join(', '));
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const toggle = (c) => setClasses(prev => {
    const next = prev.includes(c) ? prev.filter(x => x !== c) : [...prev, c];
    return LICENSE_CLASSES.filter(x => next.includes(x));
  });

  async function submit(e) {
    e.preventDefault();
    setStatus('saving');
    setMessage('');
    try {
      await carrierApi.updateDriverProfile({
        orgId,
        targetUid: member.id,
        profile: { licenseClasses: classes, languages: languages.split(',').map(s => s.trim()).filter(Boolean) },
      });
      setStatus('idle');
      if (onDone) onDone();
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Kunne ikke lagre profilen');
    }
  }

  return (
    <form onSubmit={submit} noValidate>
      <span style={ui.label}>Førerkortklasser</span>
      <div style={ui.row}>
        {LICENSE_CLASSES.map(c => (
          <label key={c} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 14 }}>
            <input type="checkbox" checked={classes.includes(c)} onChange={() => toggle(c)} />
            <span>{c}</span>
          </label>
        ))}
      </div>
      <Field id="dp-lang" label="Språk (kommaseparert)">
        <input id="dp-lang" style={ui.input} value={languages} onChange={e => setLanguages(e.target.value)} />
      </Field>
      {status === 'error' && <p role="alert" style={ui.error}>{message}</p>}
      <button type="submit" className="tippi-btn" style={{ ...ui.btn, marginTop: 14 }} disabled={status === 'saving'}>
        {status === 'saving' ? 'Lagrer…' : 'Lagre profil'}
      </button>
    </form>
  );
}
